export interface IKeycloakProfileAttributes {
  allowedScopes?: string[];
  wlAccess?: string[];
  hidePasswordChange?: boolean;
}

export class KeycloakUserModel {
  public id: string;
  public email: string;
  public emailVerified: boolean;
  public enabled: boolean;
  public firstName: string;
  public lastName: string;
  public totp: boolean;
  public username: string;
  public attributes: IKeycloakProfileAttributes;

  constructor(user: Keycloak.KeycloakProfile & { attributes?: IKeycloakProfileAttributes }) {
    this.id = user.id!;
    this.email = user.email!;
    this.emailVerified = user.emailVerified!;
    this.enabled = !!user.enabled;
    this.firstName = user.firstName ?? '';
    this.lastName = user.lastName ?? '';
    this.username = user.username ?? '';
    this.attributes = user.attributes ?? {};
  }

  public get displayFullName(): string {
    const name = `${this.firstName} ${this.lastName}`.trim();
    return name || this.username;
  }

  public get initials(): string {
    const initials = this.firstName.charAt(0).toUpperCase() + this.lastName.charAt(0).toUpperCase();
    const usernameInitial = this.username.charAt(0).toUpperCase();
    return initials || usernameInitial || 'N/A';
  }
}
